function Contact() {
  return (
    <section id='contact' className='w-screen bg-stone-200 p-5'>
      <p className='text-center font-semibold'>kornberg.grayson@gmail.com</p>
    </section>
  )
}

export default Contact
